import { Injectable } from '@angular/core';
import { Params, Router } from '@angular/router';

import { Label } from 'src/app/shared/framework/labels/models/Label';
import { OverlayModalComponent } from 'src/app/shared/framework/modals/components/overlay-modal/overlay-modal.component';

import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Subscription } from 'rxjs';
import { DelegatedTeam } from 'src/app/auth/models/UserData';
import { AuthService } from 'src/app/auth/services/auth.service';
import { LabelService } from 'src/app/shared/framework/labels/services/label.service';
import { EmployeeDatePipe } from 'src/app/shared/pipes/pipes/employee-date.pipe';
import { Task, TaskCategory, TaskPhoto } from '../models/Task';
import { TaskOverview } from '../models/TaskOverview';
import { ELearningService } from 'src/app/modules/lms/e-learnings/services/elearning.service';

@Injectable({
  providedIn: 'root',
})
export class TaskLogicService {
  private reviewBox: Window;
  private timer: Subscription;
  private dt: DelegatedTeam;
  private labels: Label[] = [];
  constructor(
    private elearningService: ELearningService,
    private _router: Router,
    private modalService: NgbModal,
    private _authService: AuthService,
    private employeeDatePipe: EmployeeDatePipe,
    private labelService: LabelService
  ) {
    this.dt = this._authService.getActiveDelegation();
  }

  public getNavigationDetails(task: Task): Params {
    return this.getQueryParams(task);
  }

  public bundleTasks(
    overview: TaskOverview,
    studentTasksOnly: boolean = false,
    teamTasksOnly: boolean = false
  ): Task[] {
    this.dt = this._authService.getActiveDelegation();
    const tasks: Task[] = [];
    for (const property in overview) {
      if (
        overview.hasOwnProperty(property) &&
        typeof (overview[property] === 'object') &&
        overview[property] &&
        property !== 'taskNameLabels' &&
        overview[property].length
      ) {
        tasks.push(...overview[property]);
      } else if (property === 'courseRequestTasks') {
        if (overview['courseRequestTasks']) {
          if (overview['courseRequestTasks']['counterCourseRequestTasks'] > 0) {
            tasks.push(overview['courseRequestTasks']);
          }
        }
      } else if (
        overview.hasOwnProperty(property) &&
        typeof (overview[property] === 'object') &&
        overview[property] &&
        property === 'taskNameLabels' &&
        overview[property].length
      ) {
        this.labels.push(...overview[property]);
      }
    }
    // this.dt = this._authService.getActiveDelegation();
    tasks.forEach((task) => {
      this.setImage(task);
      this.setIsTeamTask(task);

      if (this.dt != null) {
        task.url = task.url + '&delegate=1&studentid=' + this.dt.studentId;
      }

      if (
        typeof this.labels.find(
          (label) =>
            label.labelName === TaskCategory[task.category].toLowerCase()
        ) !== 'undefined'
      ) {
        if (
          TaskCategory[task.category].toLowerCase() !==
          'certificateelearning' &&
          TaskCategory[task.category].toLowerCase() !== 'elearning'
        ) {
          task.name = this.labels.find(
            (label) =>
              label.labelName === TaskCategory[task.category].toLowerCase()
          ).labelText

          if (
            task.category == TaskCategory.ReviewTeam &&
            task.taskAsN2 &&
            task.manager
          ) {
            task.name = this.labels.find(
              (label) => label.labelName === 'reviewteamn2'
            ).labelText;
            task.description = this.labels.find(
              (label) => label.labelName === 'reviewteamn2description'
            ).labelText;
          }

          if (
            task.category == TaskCategory.OwnInformalConversation &&
            task.isPrivate
          ) {
            task.name = this.labels.find(
              (label) => label.labelName === 'owninformalconversationprivate'
            ).labelText;
          }

          if (
            task.category == TaskCategory.InformalConversationTeam &&
            task.isPrivate
          ) {
            task.name = this.labels.find(
              (label) => label.labelName === 'informalconversationteamprivate'
            ).labelText;
          }

          task = this.getSpecialLabels(task);

          task.name = this.replace(task.name, task);
          task.description = this.replace(task.description, task);


          if (
            TaskCategory[task.category].toLowerCase() == 'plannedcoursedays'
          ) {
            task.name += ' "' + task.courseName + '" ';

            if (task.sessionName) {
              this.labelService.getLabel('session', 'general').subscribe(e => {
                task.name += '(' + e?.labelText + ' ' + task.sessionName + ')';
              });
            }


            this.employeeDatePipe
              .transform(task.taskSettingDate)
              .subscribe((e) => {
                task.description =
                  e + ' (' + task.startTime + ' - ' + task.endTime + ')';
              });
          }

          // if ([
          //   TaskCategory.CourseConfirm,
          //   TaskCategory.CourseConfirmTeam
          // ].includes(task.category) &&
          //   task.sessionsCount == 1) {
          //   this.employeeDatePipe.transform(task.courseDateFirstSession).subscribe((e) => {
          //     task.description = e + " " + task.description.substring(task.description.indexOf('('));
          //   });
          // }

        } else {
        }
      } else {
        task.name =
          'something wrong: tasklabel not working correctly' +
          TaskCategory[task.category];
      }
    });

    tasks.sort((a: Task, b: Task) => {
      if (a.category < b.category) {
        return -1;
      } else if (a.category > b.category) {
        return 1;
      } else {
        return 0;
      }
    });

    if (teamTasksOnly) {
      return tasks.filter((e) => e.isTeamTask);
    } else if (studentTasksOnly) {
      return tasks.filter((e) => !e.isTeamTask);
    } else {
      return tasks;
    }
  }

  public getSpecialLabels(task: Task): Task {
    if ([
      TaskCategory.CourseConfirm,
      TaskCategory.CourseConfirmTeam
    ].includes(task.category) &&
      task.sessionsCount > 1) {
      task.description = this.labels.find(
        (label) =>
          label.labelName === (TaskCategory[task.category].toLowerCase() + "multiplesessions")
      ).labelText
    }
    return task;
  }

  public replace(input: string, task: Task): string {
    if (input && task) {
      if (input.indexOf('[Employee]') > -1 && (task.studentName || task.studentFullName)) {
        input = input.replace(/\[Employee\]/gi, task.studentName || task.studentFullName);
      }

      if (input.indexOf('[StudentName]') > -1 && (task.studentName || task.studentFullName)) {
        input = input.replace(/\[StudentName\]/gi, task.studentName || task.studentFullName);
      }

      if (input.indexOf('[Employee]') > -1 && (task.studentName || task.studentFullName)) {
        input = input.replace(/\[Employee\]/gi, task.studentName || task.studentFullName);
      }

      if (input.indexOf('[Candidate]') > -1 && task.candidateFirstName || task.candidateLastName) {
        input = input.replace(/\[Candidate\]/gi, task.candidateFirstName + ' ' + task.candidateLastName);
      }

      if (input.indexOf('[Manager]') > -1 && task.manager) {
        input = input.replace(/\[Manager\]/gi, task.manager);
      }

      if (input.indexOf('[TemplateName]') > -1 && task.templateName) {
        input = input.replace(/\[TemplateName\]/gi, task.templateName);
      }
      if (input.indexOf('[Templatename]') > -1 && task.templateName) {
        input = input.replace(/\[TemplateName\]/gi, task.templateName);
      }

      if (input.indexOf('[CourseName]') > -1 && task.courseName) {
        input = input.replace(/\[CourseName\]/gi, task.courseName);
      }

      if (input.indexOf('[SessionsCount]') > -1 && task.sessionsCount) {
        input = input.replace(/\[SessionsCount\]/gi, task.sessionsCount.toString());
      }

      if (input.indexOf('[CourseDateFirstSession]') > -1 && task.courseDateFirstSession) {
        this.employeeDatePipe.transform(task.courseDateFirstSession).subscribe((e) => {
          input = input.replace(/\[CourseDateFirstSession\]/gi, e);
        });
      }

      if (input.indexOf('[GenderStudent]') > -1 && task.genderLabel) {
        input = input.replace(/\[GenderStudent\]/gi, task.genderLabel);
      }

      if (input.indexOf('[CourseDateLastSession]') > -1 && task.courseDateLastSession) {
        this.employeeDatePipe.transform(task.courseDateLastSession).subscribe((e) => {
          input = input.replace(/\[CourseDateLastSession\]/gi, e);
        });
      }

      if (input.indexOf('[WhoName]') > -1 && task.whoName) {
        input = input.replace(/\[WhoName\]/gi, task.whoName);
      }

      if (input.indexOf('[ConversationName]') > -1 && task.conversationName) {
        input = input.replace(/\[ConversationName\]/gi, task.conversationName);
      }

      return input;
    } else {
      return null;
    }
  }

  private getQueryParams(task: Task): Params {
    this.dt = this._authService.getActiveDelegation();

    let params: Params = null;
    switch (task.category) {
      case TaskCategory.CertificateElearning:
        // overlay voor de e-learning
        break;
      case TaskCategory.Elearning:
        // overlay
        break;
      case TaskCategory.CourseEval:
        params = {
          ceevalid: task.courseEventEvaluationID,
          item: task.studentEvaluationID,
          courseeventparticipantID: task.courseEventParticipantID,
          courseevent: task.eventID,
        };
        break;
      case TaskCategory.PlannedCourseDays:
        params = {
          courseEventSessionID: task.courseEventSessionID,
          id: task.courseEventParticipantID,
        };
        break;
      case TaskCategory.CertificateElearning:
        break;
      case TaskCategory.CertificateAssessment:
        params = {
          item: task.assessmentID,
          certificate: task.certificateID,
          from: 'home',
        };
        break;
      case TaskCategory.CertificateRequirementConfirmation:
        params = {
          redirect: 'studenthome',
          item: task.studentId,
          req: task.certificateRequirementID,
          cert: task.certificateID,
          certreqid: task.certificateRequirementPerCertificateID,
          action: 1,
          insert: 1,
        };
        break;
      case TaskCategory.CertificateResponsible:
        params = { item: task.certificateID, viewdetail: 0 };
        break;
      case TaskCategory.CertificateTeam:
        params = { item: task.studentId, cy: task.companyID, certredir: 1 };
        if (this.dt != null) {
          params = {
            item: task.studentId,
            cy: task.companyID,
            certredir: 1,
            delegate: 1,
            studentid: this.dt.studentId,
          };
        }
        break;
      case TaskCategory.CourseConfirm:
        params = {
          student: task.studentId,
          event: task.eventID,
          courseeventparticipantid: task.courseEventParticipantID,
        };

        break;
      case TaskCategory.CourseConfirmTeam:
        params = {
          item: task.courseEventParticipantID,
          event: task.eventID,
          go: 'mgr',
        };
        if (this.dt != null) {
          params = {
            item: task.courseEventParticipantID,
            event: task.eventID,
            go: 'mgr',
            delegate: 1,
            studentid: this.dt.studentId,
          };
        }
        break;
      case TaskCategory.CourseEvalTeam:
        params = {
          ceevalid: task.courseEventEvaluationID,
          item: task.studentEvaluationID,
          courseeventparticipantid: task.courseEventParticipantID,
          courseevent: task.eventID,
          who: 2,
        };
        if (this.dt != null) {
          params = {
            ceevalid: task.courseEventEvaluationID,
            item: task.studentEvaluationID,
            courseeventparticipantid: task.courseEventParticipantID,
            courseevent: task.eventID,
            who: 2,
            delegate: 1,
            studentid: this.dt.studentId,
          };
        }
        break;
      case TaskCategory.CourseInPicture:
        params = { item: task.courseID, student: task.studentId };
        break;
      /*case TaskCategory.CourseRequest:
        params = {
          reff: 'mhp',
          from: 'mgrlist',
          app: 1,
          request: task.courseRegistrationRequestID,
          student: task.studentID,
          originating: 'home'
        };
        break;*/
      case TaskCategory.InformalConversationTeam:
        params = { actor: task.act, revcomment: task.reviewCommentID };
        break;
      case TaskCategory.InformalConversationPeer:
        params = { actor: 'peer', revcomment: task.reviewCommentID };
        break;
      case TaskCategory.OwnInformalConversation:
        params = { actor: 'self', revcomment: task.reviewCommentID };
        break;
      case TaskCategory.PreAssessment:
        params = {
          courseEventParticipantID: task.courseEventParticipantID,
          item: task.preAssessmentID,
          kind: 1,
        };
        break;
      case TaskCategory.PostAssessment:
        params = {
          item: task.postAssessmentID,
          courseEventParticipantID: task.courseEventParticipantID,
          kind: 2,
        };
        break;
      case TaskCategory.PositionFlow:
        if (task.rework === 1) {
          params = {
            item: task.positionID,
            target: 'addchangeposition',
            rework: task.flowID,
            reworker: task.rework,
          };
        } else {
          params = {
            item: task.flowID,
            reworker: task.rework,
          };
        }
        break;
      case TaskCategory.Bookmark:
        params = { ID: task.id };
        break;
      case TaskCategory.Review:
      case TaskCategory.ReviewTeam:
      case TaskCategory.ReviewTeamSetDate:
        break;
      case TaskCategory.NotPresence:
        params = {
          template: task.studentActionsSetupID,
          item: task.studentActionsID,
          fr: 'tasks',
        };
        if (this.dt != null) {
          params = {
            template: task.studentActionsSetupID,
            item: task.studentActionsID,
            fr: 'tasks',
            delegate: 1,
            studentid: this.dt.studentId,
          };
        }
        break;
    }

    return params;
  }
  /*public setLabel(taskCategory : TaskCategory): Task {

    return task;
  }*/

  public setImage(task: Task): Task {
    task.profilePicture = null;
    task.profilePictureId = 0;
    if (task.fileData != null && task.contentType != null) {
      const taskPhoto: TaskPhoto = {
        fileData: task.fileData,
        contentType: task.contentType,
        fileName: '',
        fileSize: '0',
      };

      task.profilePicture = taskPhoto;
      task.profilePictureId = 1;
    }
    return task;
  }

  public setDelegateUrlTask(task: Task, realManagerId: number) { }

  public setIsTeamTask(task: Task): Task {
    switch (task.category) {
      /*case TaskCategory.ActorInterview:
        task.isTeamTask = true;
        break;*/
      case TaskCategory.ApprovalJobopening:
      case TaskCategory.CertificateAssessmentTeam:
      case TaskCategory.CertificateTeam:
      case TaskCategory.CourseConfirmTeam:
      case TaskCategory.CourseRequest:
      case TaskCategory.CourseEvalTeam:
      case TaskCategory.CourseGroupTeam:
      case TaskCategory.InformalConversationTeam:
      case TaskCategory.ReviewTeam:
      case TaskCategory.ReviewTeamSetDate:
      case TaskCategory.ConversationsTeam:
      case TaskCategory.ConversationsSignTeam:
      case TaskCategory.Review360PeerValidate:
      case TaskCategory.PositionFlow:
      case TaskCategory.NotPresence:
      case TaskCategory.SkillEntryTeam:
        task.isTeamTask = true;
        break;
      default:
        task.isTeamTask = false;
    }
    return task;
  }

  openOverlay(url) {
    let instance = this.modalService.open(OverlayModalComponent, {
      size: 'xxl',
      backdrop: 'static',
      windowClass: 'overlay-modal'
    });
    instance.componentInstance.url = url;

    instance.result.then(
      () => {
        window.location.reload();
      },
      () => {
        window.location.reload();
      }
    );
  }

  public navigateToTaskDetail(task: Task): void {
    this.dt = this._authService.getActiveDelegation();
    const params: Params = this.getNavigationDetails(task);

    if (task.category === TaskCategory.CertificateElearning) {
      this.elearningService.startScorm(
        task.eLearningParticipantID,
        task.studentId,
        task.trainingVendorCourseID,
        task.eLearningParticipantID === 0 ? 'no' : 'yes',
        false,
        task.name
      );
    } else if (task.category === TaskCategory.Review) {
      this.openOverlay(task.url);
    } else if (task.category === TaskCategory.ReviewTeam) {
      this.openOverlay(task.url);
    } else if (task.category === TaskCategory.ReviewTeamSetDate) {
      this.openOverlay(task.url);
    } else if (task.category === TaskCategory.Review360PeerExecutor) {
      this.openOverlay(task.url);
    } else if (task.category === TaskCategory.Review360PeerSelect) {
      this.openOverlay(task.url);
    } else if (task.category === TaskCategory.Review360PeerValidate) {
      this.openOverlay(task.url);
    } else if (task.category === TaskCategory.Elearning) {
      this.elearningService.startScorm(
        task.eLearningParticipantID,
        task.studentId,
        task.trainingVendorCourseID,
        task.eLearningParticipantID === 0 ? 'no' : 'yes',
        task.isTelevic,
        task.name,
        task.studentActivityID,
        task.learningPathID
      );
    } else if (task.category === TaskCategory.LearningPath) {
      let paramsLp: Params = null;
      paramsLp = {
        activity: task.studentActivityID,
      };
      this._router.navigate(
        ['/lms/learnpaths/ess/details/', task.learningPathID],
        {
          queryParams: paramsLp,
        }
      );
    } else if (task.category === TaskCategory.LearningPathCourseReEnter) {
      let paramsLp: Params = null;
      paramsLp = {
        activity: task.studentActivityID,
      };
      this._router.navigate(
        ['/lms/learnpaths/ess/details/', task.learningPathID],
        {
          queryParams: paramsLp,
        }
      );
    } else if (task.category === TaskCategory.ActorInterview) {
      const action =
        '/PerfNav/administration/EN/common/recruitment/changeinterviewactor.asp?showcommenttab=1&item=' +
        task.candidateID.toString() +
        '&interview=' +
        task.candidateInterviewID.toString();
      // this.elearningService.openPopUp(action);
      // this.openOverlay(action);
      this._router.navigate(['/rs/changeinterviewactor'], { queryParams: { item: task.candidateID, interview: task.candidateInterviewID } });
    } else if (task.category === TaskCategory.CourseRequest) {
      if (this.dt != null) {
        this._router.navigate(['/delegate/tasks/course/requests']);
      } else {
        this._router.navigate(['/manager/tasks/courserequests']);
      }
    } else if (task.category === TaskCategory.SkillEntryTeam && task.url) {
      this._router.navigateByUrl(task.url);
    } else if (task.category === TaskCategory.CourseGroupTeam) {
      if (this.dt != null) {
        this._router.navigate(['/delegate/development/registration/groups']);
      } else {
        this._router.navigate(['/manager/development/registration-groups']);
      }
    } else if (task.category === TaskCategory.OwnInformalConversation) {
      this._router.navigate(['/my-informal-conversations'], { queryParams: { revcomment: task.reviewCommentID } });
    } else if (task.category === TaskCategory.InformalConversationPeer) {
      this._router.navigate(['/peer-informal-conversations'], { queryParams: { revcomment: task.reviewCommentID, item: task.studentId, studid: task.studentId } });
    } else if (task.category === TaskCategory.InformalConversationTeam) {
      this._router.navigate(['/manager/conversations/informal'], { queryParams: { revcomment: task.reviewCommentID, item: task.studentId, studid: task.studentId } });
    } else if (task.category === TaskCategory.Conversations || task.category === TaskCategory.ConversationsTeam) {
      this._router.navigate(['/conversations/current-conversation/', task.conversationId]);
    } else if (task.category === TaskCategory.ConversationsSign || task.category === TaskCategory.ConversationsSignTeam) {
      this._router.navigate(['/conversations/current-conversation/', task.conversationId]);
    } else if (task.category === TaskCategory.ConversationsPeer) {
      this._router.navigate(['/conversations/current-conversation/', task.conversationId], { queryParams: { peer: 1 } });
    } else {
      this._router.navigate(['/framework/ess/tasks/taskdetail', task.category], { queryParams: params, });
    }
  }
}
